import { __awaiter } from '../../_virtual/_tslib.js';
import { useQueryClient, useMutation } from 'react-query';
import API from '../const.js';
import { QueryNames } from './queryNames.js';
import { getAuthHeader } from '../utils/getAuthHeader.js';
import { toast } from 'react-toastify';
import { getAuthIdParam } from '../../methods/getAuthIdParam.js';
import useVahakHttpClient from '../../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery } from '../../hooks/useVahakQueryClient.js';

function usePostLoad(hookParam) {
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutation(({ companyId, loadVals, isReposted }) => fetch(API.POST_LOAD + getAuthIdParam(), {
        method: "POST",
        headers: Object.assign({}, getAuthHeader()),
        body: JSON.stringify({
            quantity: parseFloat(String(loadVals.qty)),
            capacity: parseFloat(String(loadVals.lorryCapacity)),
            length: parseFloat(String(loadVals.len || 0.0)),
            breadth: parseFloat(String(loadVals.breadth || 0.0)),
            height: parseFloat(String(loadVals.height || 0.0)),
            expected_amount: parseFloat(String(loadVals.amount)),
            material_type: loadVals.material,
            payment_type: Number(loadVals.paymentType),
            is_odc: !!loadVals.isOdc,
            remarks: loadVals.remarks,
            company_id: Number(companyId),
            lorry_id: loadVals.lorryTypeId,
            // source_id: loadVals.src,
            // destination_id: loadVals.dest,
            source_place_id: loadVals.srcPlaceId,
            destination_place_id: loadVals.destPlaceId,
            is_reposted: isReposted || null,
            expected_type: loadVals.isFixedPrice ? 0 : 0,
            total_tyres: loadVals.totalTyres || 0,
            body_type: loadVals.bodyType || 0,
            size: loadVals.size || 0,
            advance_payment_percentage: parseInt(String(loadVals.advancePaymentPercentage || 0), 10),
            size_text: loadVals.sizeText,
            loading_timestamp: loadVals.loadingTimestamp,
            load_ghosting_penalty_deduction: loadVals.loadGhostingPenaltyDeduction,
            spot_load_auction_enabled: true,
            do_dup_check: true,
            is_verified: loadVals === null || loadVals === void 0 ? void 0 : loadVals.isVerified,
            verification_source: loadVals === null || loadVals === void 0 ? void 0 : loadVals.verificationSource,
            stops: loadVals === null || loadVals === void 0 ? void 0 : loadVals.stops
        })
    }), {
        onError: (err) => {
            console.log("err posting", err);
        },
        onMutate: () => queryClient.cancelQueries(QueryNames.loadsForCurrentUser),
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            (hookParam === null || hookParam === void 0 ? void 0 : hookParam.invalidateOnSuccess) && queryClient.invalidateQueries(QueryNames.loadsForCurrentUser);
        }
    });
    return { mutateAsync };
}
function usePostLorry(hookParam) {
    const queryClient = useQueryClient();
    const { mutateAsync } = useMutation(({ companyId, lorryVals }) => {
        var _a;
        return fetch(API.POST_LORRY + getAuthIdParam(), {
            method: "POST",
            headers: Object.assign({}, getAuthHeader()),
            body: JSON.stringify({
                company_id: Number(companyId),
                number: (_a = lorryVals.lorryNum) === null || _a === void 0 ? void 0 : _a.toLowerCase().replaceAll(" ", ""),
                capacity: lorryVals.lorryCapacity,
                type: lorryVals.lorryType,
                route_ids: lorryVals.routeIds,
                // documents: lorryVals.documents || null,
                current_place_id: lorryVals.currentPlaceID,
                current_city_id: lorryVals.currentCityId,
                size: lorryVals.lorrySize,
                total_tyres: lorryVals.lorryTyres,
                body_type: lorryVals.lorryBodyType
            })
        });
    }, {
        onMutate: () => queryClient.cancelQueries(QueryNames.lorriesForCurrentUser),
        onSuccess: (res) => {
            if (res.status === 401) {
                queryClient.invalidateQueries(QueryNames.validateToken);
            }
            (hookParam === null || hookParam === void 0 ? void 0 : hookParam.invalidateOnSuccess) && queryClient.invalidateQueries(QueryNames.lorriesForCurrentUser);
        }
    });
    return { mutateAsync };
}
function useReactivateLorry() {
    const { POST } = useVahakHttpClient();
    const reactivateLorry = ({ lorryId, currentPlaceID }) => {
        const payload = { lorry_id: lorryId, current_place_id: currentPlaceID };
        return POST(API.REACTIVATE_LORRY, payload);
    };
    return useVahakMutationQuery(QueryNames.userLorries.reactivateLorry, reactivateLorry);
}
function handlePostResponse(mutateFn, postingParams) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const postedItemRes = yield mutateFn(postingParams);
            if (postedItemRes.status === 200) {
                const postedLoadJson = yield postedItemRes.json();
                return { postedItemId: postedLoadJson.id, success: true, data: postedLoadJson };
            }
            else if (postedItemRes.status === 208) {
                const duplicateLoadJson = yield postedItemRes.json();
                return {
                    postedItemId: (_a = duplicateLoadJson.data) === null || _a === void 0 ? void 0 : _a.id,
                    success: false,
                    data: duplicateLoadJson
                };
            }
            else {
                const error = { message: "An Error Occurred. Please try again after some time." };
                throw error;
            }
        }
        catch (e) {
            toast.error(e.message || "An error occurred, please try again");
        }
        return { success: false };
    });
}
function handleLorryPostResponse(mutateFn, postingParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { postedItemId, success } = yield handlePostResponse(mutateFn, postingParams);
        return { lorryId: postedItemId, success };
    });
}
function handleLorryReactivateResponse(mutateFn, postingParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { success } = yield handlePostResponse(mutateFn, postingParams);
        return { success };
    });
}
function handleLoadPostResponse(mutateFn, postingParams) {
    return __awaiter(this, void 0, void 0, function* () {
        const { postedItemId, success, data } = yield handlePostResponse(mutateFn, postingParams);
        return { loadId: postedItemId, success, data };
    });
}

export { handleLoadPostResponse, handleLorryPostResponse, handleLorryReactivateResponse, usePostLoad, usePostLorry, useReactivateLorry };
//# sourceMappingURL=usePostingService.js.map
